import type { TypedSupabaseClient } from '../client';
import type {
  IProNotificationRepository,
  ProNotification,
  ProNotificationFilters,
} from '../../../interfaces/src';

export class SupabaseProNotificationRepository implements IProNotificationRepository {
  constructor(private supabase: TypedSupabaseClient) {}

  async list(filters?: ProNotificationFilters): Promise<ProNotification[]> {
    let q = (this.supabase as any)
      .from('pro_notifications')
      .select('*')
      .order('created_at', { ascending: false });
    if (filters?.unreadOnly) q = q.is('read_at', null);
    if (filters?.limit) q = q.limit(filters.limit);
    else q = q.limit(20);
    const { data, error } = await q;
    if (error) throw error;
    return ((data ?? []) as Array<Record<string, unknown>>).map(mapNotification);
  }

  async unreadCount(): Promise<number> {
    const { count, error } = await (this.supabase as any)
      .from('pro_notifications')
      .select('*', { count: 'exact', head: true })
      .is('read_at', null);
    if (error) throw error;
    return count ?? 0;
  }

  async markRead(id: string): Promise<void> {
    const { error } = await (this.supabase as any)
      .from('pro_notifications')
      .update({ read_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw error;
  }

  async markAllRead(): Promise<number> {
    const { data, error } = await (this.supabase as any).rpc(
      'pro_notifications_mark_all_read',
    );
    if (error) throw error;
    return Number(data ?? 0);
  }
}

function mapNotification(row: Record<string, unknown>): ProNotification {
  return {
    id: row['id'] as string,
    tenantId: row['tenant_id'] as string,
    proCustomerId: row['pro_customer_id'] as string,
    type: row['type'] as ProNotification['type'],
    title: row['title'] as string,
    body: (row['body'] as string) ?? null,
    linkUrl: (row['link_url'] as string) ?? null,
    readAt: (row['read_at'] as string) ?? null,
    createdAt: row['created_at'] as string,
  };
}
